import api from './api';
import type { Blockout, CalendarDoctor } from '@/types';

/**
 * Local-clinic doctor-day view (FEATURE_DOCTOR_DAY_VIEW). All routes 404
 * unless the clinic profile / env enables the flag.
 */

// Active users with the doctor role — the day-view columns.
export const getCalendarDoctors = async () => {
  const response = await api.get<{ data: CalendarDoctor[] }>('/calendar/doctors');
  return response.data.data;
};

// Blockout windows overlapping [start, end).
export const getBlockouts = async (start: string, end: string, userId?: number) => {
  const params = new URLSearchParams({ start, end });
  if (userId) params.append('user_id', String(userId));
  const response = await api.get<{ data: Blockout[] }>(`/blockouts?${params}`);
  return response.data.data;
};

/**
 * Exactly one of user_id / room_id: the API enforces the XOR (`prohibits`
 * on create — send only the key that applies; on update both may be sent,
 * one of them null, to switch scope).
 */
export interface BlockoutPayload {
  user_id?: number | null;
  room_id?: string | null;
  starts_at: string;
  ends_at: string;
  reason?: string | null;
  label?: string | null;
}

/** Store/update respond with a warn-don't-block overlap count. */
export interface BlockoutWriteResponse {
  data: Blockout;
  conflicting_appointments: number;
}

export const createBlockout = async (payload: BlockoutPayload) => {
  const response = await api.post<BlockoutWriteResponse>('/blockouts', payload);
  return response.data;
};

export const updateBlockout = async (id: string, payload: Partial<BlockoutPayload>) => {
  const response = await api.put<BlockoutWriteResponse>(`/blockouts/${id}`, payload);
  return response.data;
};

export const deleteBlockout = async (id: string) => {
  await api.delete(`/blockouts/${id}`);
};
